// eslint-disable-next-line no-unused-vars
import { Vehicle } from '@/generated-clients/myTrips'

export function formatVehicle (vehicle: Vehicle) {
  const { brand, model, licensePlate } = vehicle
  return licensePlate ? `${brand} ${model} (${licensePlate})` : `${brand} ${model}`
}
